import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./Markdown.css";

/**
 * Renders AI text (headings, bold, lists, tables) as proper formatting.
 * Raw HTML in the text is never rendered, so it is safe for model output.
 */
const Markdown = ({ children, className = "" }) => {
  const text = typeof children === "string" ? children : "";
  if (!text.trim()) return null;
  return (
    <div className={`eg-md ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // open links safely in a new tab
          a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
          // wide tables scroll sideways instead of breaking the layout
          table: ({ node, ...props }) => (
            <div className="eg-md-table">
              <table {...props} />
            </div>
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
};

export default Markdown;
